// extracted by mini-css-extract-plugin
module.exports = {"centeredCol":"BundleHeaderPageSegment-CenteredCol-module--centered-col--2UcMf"};